// Look for the digitalData object structure in the mocks folder

// ============ Helper Functions ============

const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('development') || hostname.includes('localhost'))
    return 'development';
  if (hostname.includes('staging')) return 'staging';
  return 'production';
};

const getExperienceType = () => {
  // Using window.navigator.userAgent for device detection
  const userAgent = window.navigator.userAgent.toLowerCase();

  // Check if it's a mobile device
  const isMobile =
    /mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(
      userAgent
    );

  // Check if it's a tablet
  const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(
    userAgent
  );

  if (isMobile) return 'Mobile';
  if (isTablet) return 'Tablet';
  return 'Desktop';
};

// Sanitize input to prevent HTML5 storage manipulation
const sanitizeInput = (input) => {
  if (typeof input !== 'string') return '';

  // Remove potentially harmful content
  return input
    .replace(/[<>"'`]/g, '') // Remove HTML special chars
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/data:/gi, '') // Remove data: URLs
    .replace(/on\w+=/gi, ''); // Remove event handlers
};

// ============ Digital Data Object Building ============

const getPageURLData = () => {
  // Sanitize URL data before storing
  const safeHref = sanitizeInput(window.location.href || '');
  const safeOrigin = sanitizeInput(window.location.origin || '');
  const safeHostname = sanitizeInput(window.location.hostname || '');
  const safePath = sanitizeInput(window.location.pathname || '');
  const safeSearch = sanitizeInput(window.location.search || '');
  const safeHash = sanitizeInput(window.location.hash || '');

  return {
    ancestorOrigins: window.location.ancestorOrigins || {},
    href: safeHref,
    origin: safeOrigin,
    protocol: window.location.protocol || '',
    host: window.location.host || '',
    hostname: safeHostname,
    port: window.location.port || '',
    pathname: safePath,
    search: safeSearch,
    hash: safeHash
  };
};

const getPageInfo = () => {
  // Sanitize referrer before storing it
  const safeReferrer = sanitizeInput(document.referrer || '');

  return {
    breadCrumbs: '',
    pageName: document.documentElement.lang || '',
    pageTitle: document.title || '',
    pageType: (() => {
      const path = window.location.pathname;
      if (path.includes('/forgot-password')) return 'forgot-password';
      if (path.includes('/reset-password')) return 'reset-password';
      if (path.includes('/forgot-email')) return 'forgot-email';
      if (path.includes('/reset-temp-password')) return 'reset-temp-password';
      return 'login';
    })(),
    navigationCategory: 'authentication',
    PageURL: getPageURLData(),
    referrer: safeReferrer,
    referringURL: safeReferrer
  };
};

const collectPageAttributes = () => {
  const fullLang = document.documentElement.lang || '';
  const language = fullLang.split('-')[0] || 'en';
  const country = fullLang.split('-')[1] || '';

  const path = window.location.pathname;
  let errorPage = '';

  if (path.includes('404')) {
    errorPage = '404';
  } else if (path.includes('500')) {
    errorPage = '500';
  } else if (path.includes('invalid-request')) {
    errorPage = 'invalid-request';
  }

  return {
    errorPage,
    domain: window.location.hostname || '',
    currencyCode: '',
    country,
    experience: getExperienceType(),
    language
  };
};

const getPageData = () => {
  return {
    pageInfo: getPageInfo(),
    attributes: collectPageAttributes()
  };
};

const getUserData = () => {
  return {
    authState: 'logged out',
    CustomerId: '',
    UnitId: ''
  };
};

const initializeDigitalData = () => {
  return {
    version: '5.25.0',
    pageInstanceId: `${document.title.toLowerCase()} - ${getEnvironment()}`,
    page: getPageData(),
    User: getUserData()
  };
};

window.digitalData = initializeDigitalData();
